import React, {useEffect} from 'react';

import 'pages/login-page/login-page.less';
import {AuthPage} from 'pages/auth-page/auth-page';
import {useProfileLoader} from 'pages/login-page/use-profile-loader/use-profile-loader';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {getTwoFAConfig, selectTwoFactorAuthTypeCode, EAuthProfile} from 'store/slices/auth-slice';

import {TwoFactorAuthPageForm} from './two-factor-auth-page-form';

export const TwoFactorAuthPage = () => {
    const dispatch = useAppDispatch();
    const twoFactorAuthTypeCode = useAppSelector(selectTwoFactorAuthTypeCode);

    const {
        profile,
    } = useProfileLoader();

    useEffect(() => {
        if (!profile) return;

        if (profile === EAuthProfile.LDAP && !twoFactorAuthTypeCode) {
            dispatch(getTwoFAConfig());
        }
    }, [profile, twoFactorAuthTypeCode]);

    return (
        <div className="login-page">
            <AuthPage
                className="d-flex flex-direction-row justify-content-center align-items-center"
            >
                <TwoFactorAuthPageForm />
            </AuthPage>
        </div>
    );
};
